import React from "react";
import styles from "./YourOwnStuffContent.module.css";
import backIcon from "../icons/back_icn.png";

function YourOwnStuffContent({ onBack, onNavigateToStep }) {
  return (
    <div className={styles.yourOwnStuffContentContainer}>
      <img
        src={backIcon}
        alt="Back"
        className={`${styles.backIcon} ${styles.visible}`}
        onClick={onBack}
      />
      <h1 className={styles.pageTitle}>Your Own Stuff</h1>
      <div className={`${styles.content} ${styles.visible}`}>
        <img src="/logo.svg" className={styles.appLogo} alt="logo" />
        <div className={styles.buttonContainer}>
          <button
            className={styles.button}
            onClick={() => onNavigateToStep(3)}
          >
            <div className={styles.buttonContent}>
              <span className={styles.buttonText}>YOUR FILES</span>
            </div>
          </button>

          <button
            className={styles.button}
            onClick={() => onNavigateToStep(4)}
          >
            <div className={styles.buttonContent}>
              <span className={styles.buttonText}>FAV BEATS</span>
            </div>
          </button>

	  <button
            className={styles.button}
            onClick={() => onNavigateToStep(5)}
          >
            <div className={styles.buttonContent}>
              <span className={styles.buttonText}>SUPPORT</span>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}

export default YourOwnStuffContent;
